import classNames from "classnames";
import classes from "~/features/productDetails/components/PhaseInOut/DiscontinuationNotification/DiscontinuationNotification.module.less";
import { getProductData, type ProductData } from "~/domains/product/types/ProductData";
import { SlicedImage } from "~/features/productDetails/components/PhaseInOut/SlicedImage/SlicedImage";
import { getPrimaryImage } from "~/utils/product/getPrimaryImage";
import { ImageFormat } from "~/domains/product/types/ProductDataDTO";
import { Trans, useTranslation } from "react-i18next";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

interface Props {
  className?: string;
  discontinued: ProductData | ProductDescriptor;
  variant: "product" | "package";
}

export const DiscontinuationNotification = (props: Props) => {
  const { t } = useTranslation();
  const product = getProductData(props.discontinued);
  const imgUrl = getPrimaryImage(product.images, { imageFormat: ImageFormat.product })?.url ?? "";
  const imgConfig = {
    src: imgUrl,
    sliceSize: props.variant === "product" ? 2 : 1,
    gapSize: props.variant === "product" ? 3 : 1,
  };
  return (
    <div className={classNames(classes.root, props.className, props.variant === "product" && classes.product)}>
      <div className={classes.bar} />
      <div className={classes.imageContainer}>
        <SlicedImage className={classes.image} {...imgConfig} />
      </div>
      {props.variant === "package" && (
        <div className={classes.content}>
          <p className={classNames(classes.headline, classes.headlineBig)}>
            {t("page.pdp.phaseinout.discontinuation.headline.basic")}
          </p>
          <p className={classes.description}>{t("page.pdp.phaseinout.discontinuation.description.packaging")}</p>
        </div>
      )}
      {props.variant === "product" && (
        <div className={classes.content}>
          <p className={classes.headline}>
            <Trans i18nKey={"page.pdp.phaseinout.discontinuation.headline.extended"}>
              <span className={classes.headlineBig}>Discontinuation</span>
              <br />
              <span>of the product is coming.</span>
            </Trans>
          </p>
          <p className={classes.description}>
            {t("page.pdp.phaseinout.discontinuation.description.product", { designation: product.designation })}
          </p>
        </div>
      )}
    </div>
  );
};
